export default __webpack_public_path__ + "static/media/general2024RealCase1-mobile.e01df504.jpg";